import axios from 'axios'
import {
  ProgramPurseResourceSchema,
  GetPurseDistributionsResponseSchema,
} from '@/queries/program_purses/schemas.ts'

export type GetPurseParams = {
  purseId: string
  programId: number
}
export const getPurseById = async ({ purseId, programId }: GetPurseParams) => {
  const response = await axios.get(`/programs/${programId}/purses/${purseId}`)
  return ProgramPurseResourceSchema.parse(response.data)
}

type PurseDistributionsParams = {
  programId: number
  purseId: number
}

export const getPurseDistributions = async (
  params: PurseDistributionsParams
) => {
  const { programId, purseId } = params
  const response = await axios.get(
    `/programs/${programId}/purses/${purseId}/list_distributions`
  )
  return GetPurseDistributionsResponseSchema.parse(response.data)
}

export type DownloadDistributionReportParams = {
  programId: number
  purseId: number
  distributionId: number
  password: string
}

export const downloadDistributionReport = async (
  params: DownloadDistributionReportParams
) => {
  const { programId, purseId, distributionId, password } = params
  const response = await axios.post(
    `/programs/${programId}/purses/${purseId}/distributions/${distributionId}/download_distribution_report`,
    { password },
    { responseType: 'blob' }
  )

  return response.data
}

export type DownloadDistributionPlanPreviewReportParams = {
  programId: number
  purseId: number
  distributionStrategy: 'single'
}

export async function downloadDistributionPlanPreviewReport({
  programId,
  purseId,
  distributionStrategy = 'single',
}: DownloadDistributionPlanPreviewReportParams) {
  const response = await axios.get(
    '/scholarships/distribution/download_distribution_preview_report',
    {
      params: {
        distribution_strategy: distributionStrategy,
        program_id: programId,
        program_purse_id: purseId,
      },
      responseType: 'blob',
    }
  )
  return response.data
}
